import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { UserSubscription } from '~/graphql/types'

@Module({
  name: 'backend-admin',
  stateFactory: true,
  namespaced: true,
})
export default class BackendAdmin extends VuexModule {
  loading = true
  items: UserSubscription['user'] = []

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
